type GAEvent =
  | { name: 'sign_up'; params: { user_role: 'family' | 'carer' } }
  | { name: 'onboarding_completed'; params: { user_role: 'family' | 'carer' } }
  | { name: 'search_performed'; params?: Record<string, never> }
  | { name: 'profile_view'; params: { verified_status: boolean } }
  | { name: 'booking_request_sent'; params?: Record<string, never> }
  | { name: 'booking_request_accepted'; params?: Record<string, never> };

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export function trackEvent(event: GAEvent) {
  window.gtag?.('event', event.name, event.params ?? {});
}
